import { render } from "./GwNoticeText.vue?vue&type=template&id=038056ee&scoped=true"
import script from "./GwNoticeText.vue?vue&type=script&lang=js"
export * from "./GwNoticeText.vue?vue&type=script&lang=js"

import "./GwNoticeText.vue?vue&type=style&index=0&id=038056ee&scoped=true&lang=less"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038056ee"]])

export default __exports__